import React from 'react'
import { graphql } from 'gatsby'

import Layout from 'global/layout/Layout'
import CardStructure from 'components/index/CardStructure'
import ErrorTextblock from './404/ErrorTextblock'
import HeaderBackground from 'images/404-image.png'
import './404.scss'

const Page404 = ({ data, location }) => {
  //   let permalink = location.pathname
  //   let pathParts = location.pathname.split("/break/")
  //   if (pathParts.length === 2) {
  //     permalink = pathParts[1]
  //   }

  //   console.log(`404 -> ${permalink}`)

  return (
    <Layout>
      <div className="page404">
        <div
          className="section-header"
          style={{ backgroundImage: `url(images/404-image.png)` }}
        >
          <div className="container">
            <ErrorTextblock />
            <img src={HeaderBackground} />
          </div>
        </div>
        <main>
          <CardStructure
            breaks={data.recent.nodes}
            tag="Recent"
            showAll={true}
          />
        </main>
      </div>
    </Layout>
  )
}

export const homepageQuery = graphql`
  query page404Query {
    recent: allBreak(
      sort: { fields: displayDateEpoch, order: DESC }
      filter: { isSponsored: { eq: false }, hideOnHomepage: { eq: false } }
      limit: 24
    ) {
      nodes {
        categories
        permalink
        tags
        displayDateEpoch
        featuredImageUrl
        heroImageUrl
        isSponsored
        permalink
        title
        step_types
        points
        id
      }
    }
  }
`

export default Page404
